(function () {
  const SECTION_ID = 'smart-collection-prod-options';
  const COLLECTION_VIEW = 'smart-prod-options';

  function mergeProductOptions(items, state) {
    if (!items || !items.length || !state) return;

    const seenVariantIds = new Set(
      state.prod_option.map((entry) => String(entry.variant_id))
    );

    for (const item of items) {
      const variantId = String(item.variant_id);
      if (seenVariantIds.has(variantId)) continue;
      seenVariantIds.add(variantId);

      state.prod_option.push({
        variant_id: item.variant_id,
        option: item.option,
        option_new: item.option_new,
        product_opt1: String(item.product_opt1),
        available: String(item.available),
        url: item.url,
        full_url: item.full_url,
        id: item.id,
        product_id: item.product_id,
        product_sku: item.product_sku,
        product_title: item.product_title,
        product_type: item.product_type,
        product_price: item.product_price,
        product_price_amount: item.product_price_amount,
        productcomPrice: item.productcomPrice,
      });

      state.prod_option1[item.option] = String(item.product_opt1);

      if (item.option_slots && item.option_slots.length) {
        for (const slot of item.option_slots) {
          state.prod_option2.push(slot);
        }
      }

      state.prod_option_obj.push({
        variant_id: item.variant_id,
        price_amount: item.product_price_amount,
        options: item.options || {},
      });
    }
  }

  function sortProdOption(prod_option, compareIndex) {
    if (!compareIndex || !prod_option.length) return;

    prod_option.sort(function (a, b) {
      const a_parts = a.option_new.split('|!');
      const b_parts = b.option_new.split('|!');
      for (let i = 0; i < Math.min(a_parts.length, b_parts.length); i++) {
        const a_item = a_parts[i];
        const b_item = b_parts[i];
        const a_index = compareIndex[a_item];
        const b_index = compareIndex[b_item];
        if (a_index !== undefined && b_index !== undefined) {
          if (a_index < b_index) return -1;
          if (a_index > b_index) return 1;
        } else if (a_index !== undefined) {
          return -1;
        } else if (b_index !== undefined) {
          return 1;
        }
      }
      return a_parts.length - b_parts.length;
    });
  }

  function parseItemsFromHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const jsonEl = doc.querySelector('#smart-collection-prod-options-json');
    if (jsonEl && jsonEl.textContent) {
      return JSON.parse(jsonEl.textContent);
    }

    const match = html.match(/<script[^>]*id=["']smart-collection-prod-options-json["'][^>]*>([\s\S]*?)<\/script>/i);
    if (match && match[1]) {
      return JSON.parse(match[1]);
    }

    return null;
  }

  function parseCollectionResponse(text, source) {
    const trimmed = text.trim();
    if (!trimmed) return [];

    if (source === 'view' || trimmed.startsWith('[')) {
      return JSON.parse(trimmed);
    }

    const fromHtml = parseItemsFromHtml(trimmed);
    if (fromHtml) return fromHtml;

    return [];
  }

  async function fetchCollectionPage(collectionHandle, page) {
    const root = window.Shopify?.routes?.root || '/';
    const viewUrl = `${root}collections/${collectionHandle}?view=${COLLECTION_VIEW}&page=${page}`;
    const sectionUrl = `${root}collections/${collectionHandle}?section_id=${SECTION_ID}&page=${page}`;

    const viewResponse = await fetch(viewUrl);
    if (viewResponse.ok) {
      const text = await viewResponse.text();
      try {
        const items = parseCollectionResponse(text, 'view');
        if (items && items.length) {
          return items;
        }
      } catch (error) {
        console.warn(`Smart collection view parse failed for page ${page}`, error);
      }
    }

    const sectionResponse = await fetch(sectionUrl);
    if (!sectionResponse.ok) {
      throw new Error(`Failed to fetch collection page ${page} (view: ${viewResponse.status}, section: ${sectionResponse.status})`);
    }

    const sectionText = await sectionResponse.text();
    try {
      return parseCollectionResponse(sectionText, 'section') || [];
    } catch (error) {
      console.warn(`Smart collection section parse failed for page ${page}`, error);
      return [];
    }
  }

  async function loadRemainingPages(config) {
    const {
      collectionHandle,
      productsCount,
      pageSize = 50,
      state,
      compareIndex,
      onComplete,
      onError,
    } = config;

    const totalPages = Math.ceil(productsCount / pageSize);
    if (totalPages <= 1) {
      if (typeof onComplete === 'function') onComplete();
      return;
    }

    const pageNumbers = [];
    for (let page = 2; page <= totalPages; page++) {
      pageNumbers.push(page);
    }

    try {
      const results = await Promise.all(
        pageNumbers.map((page) => fetchCollectionPage(collectionHandle, page))
      );

      let mergedCount = 0;
      for (const items of results) {
        const before = state.prod_option.length;
        mergeProductOptions(items, state);
        mergedCount += state.prod_option.length - before;
      }

      if (mergedCount === 0) {
        throw new Error('No additional smart collection products were loaded');
      }

      sortProdOption(state.prod_option, compareIndex);

      if (typeof onComplete === 'function') onComplete();
    } catch (error) {
      if (typeof onError === 'function') {
        onError(error);
      } else {
        console.error('Smart collection variant picker load failed', error);
      }
      if (typeof onComplete === 'function') onComplete();
    }
  }

  function parsePage1Element(page1El, state) {
    if (!page1El || !state) return false;

    try {
      const page1Data = JSON.parse(page1El.textContent);
      mergeProductOptions(page1Data, state);
      return state.prod_option.length > 0;
    } catch (error) {
      console.error('Smart collection page 1 JSON parse failed', error);
      return false;
    }
  }

  window.SmartCollectionVariantPicker = {
    mergeProductOptions,
    sortProdOption,
    loadRemainingPages,
    parsePage1Element,
  };
})();
